var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    style: {
      fill: "rgb(233,244,246)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.706968,0,0,0.706968,1.75819,1.75819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,3C7.5,3.549 7.951,4 8.5,4C9.049,4 9.5,3.549 9.5,3C9.5,2.451 9.049,2 8.5,2C7.951,2 7.5,2.451 7.5,3",
    style: {
      fill: "rgb(169,52,27)",
      fillRule: "nonzero",
      stroke: "rgb(169,52,27)",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.706968,0,0,0.706968,1.75819,1.75819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,5.5C4.486,5.5 4.471,5.5 4.457,5.5C3.085,5.5 1.957,6.628 1.957,8C1.957,9.371 3.085,10.5 4.457,10.5C5.254,10.5 6.005,10.118 6.475,9.475",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(169,52,27)",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.706968,0,0,0.706968,1.75819,1.75819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10L7.5,7.5L5.5,7.5L7,5L5,3.5L3,4",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(169,52,27)",
      strokeWidth: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDisabled);
export default __webpack_public_path__ + "static/media/bg-disabled.ca92c51ad4fe058d85b83b849af29267.svg";
export { ForwardRef as ReactComponent };